module.exports = __webpack_public_path__ + "img/feature-2.9f9cdb53.png";